import { type IRepeatableWidget } from '../../../widgets/repository/advanced/repeatable/IRepeatableWidget.ts';
import { Datatype } from '../../datatype/Datatype.ts';
import { type IReference, ReferenceType } from '../IReference.ts';
import { type IReferencePath } from '../IReferencePath.ts';
import { resolveChildrenReferences } from '../resolve/resolveTreeReferences.ts';

export function getArrayWidgetReference(
  path: IReferencePath,
  widget: IRepeatableWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    widgetType: widget.type,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      type: Datatype.Array,
      itemsType: Datatype.Object,
      // TODO Qui forse `path` dovrebbe essere reimpostato a `[]` in quanto stiamo
      // ragionando su un percorso "relativo" al singolo elemento della lista?
      structure: resolveChildrenReferences(path, widget),
    },
  };
}
